import { useContext } from 'react';
import { TaskFilterContext, TaskFilterContextData } from './context';

export function useTaskFilter(): TaskFilterContextData {
    const data = useContext<TaskFilterContextData | undefined>(
        TaskFilterContext
    );

    if (!data) {
        throw new Error(
            "TaskFilterContextData unavailable. Are you sure you're using this in a nested component of an TaskFilterProvider?"
        );
    }

    return data;
}
